import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { Rest } from 'app/rest/rest_client';
import { VehicleversioncategoryService } from 'app/rest/vehicleversioncategory.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';

@Component({
    selector: 'app-vehicle-category-form',
    templateUrl: './vehicle-category-form.component.html',
    styleUrls: ['./vehicle-category-form.component.css'],
    providers: [VehicleversioncategoryService],
    standalone: false
})
export class VehicleCategoryFormComponent extends EntityFormComponent<Rest.VehicleVersionCategory> implements OnInit {
    title: string;
    /*Permissions */
    canCreate: boolean = false;
    canUpdate: boolean = false;

    constructor(
        private vehicleCategoryService: VehicleversioncategoryService,
        notificationsService: NotificationsService,
        protected i18n: I18nService,
        protected authenticationService: AuthenticationService,
        private translate: TranslateService,
    ) {
        super(vehicleCategoryService, notificationsService, i18n, authenticationService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    /**
    * Loads and evaluates all the necessary data before showing the form.
    *
    * @memberof VehicleCategoryFormComponent
    */
    beforeShow() {
        const profiles = this.authenticationService.user.rolesProfiles;
        this.canCreate = profiles.some(rp => rp.profile.actions.some(a => a.name === 'VEHICLE_CATEGORY_CREATE'));
        this.canUpdate = profiles.some(rp => rp.profile.actions.some(a => a.name === 'VEHICLE_CATEGORY_UPDATE'));

        if (this.isNew) {
            this.title = this.translate.instant('tableManagement.categories.createCategory');
        } else {
            this.title = this.translate.instant('tableManagement.categories.editCategory');
        }
    }

    protected beforeSave(): void {
        this.entity.client = this.authenticationService.user.client;
    }

    save() {
        if (!this.entity.name) {
            this.notificationsService.add(
                Severity.warn,
                '',
                this.translate.instant('logistics.routes.errors.erremptyfields')
            );
            return;
        }
        super.save();
    }

    get canSave(): boolean {
        return this.isNew ? this.canCreate : this.canUpdate;
    }
}
